export enum GarageCreateItemStepsEnum {
  preStepTransportType = 'pre_step_transport_type',
  preStepSelectMethod = 'pre_step_select_method',
  preStepAI = 'pre_step_ai',
  generalBase = 'general_base',
  generalSecond = 'general_second',
  generalThird = 'general_third',
  coverPhoto = 'cover_photo',
  insuranceBase = 'insurance_base',
  insuranceSecond = 'insurance_second',
  insuranceThird = 'insurance_third',
  addVehicleRegistration = 'vehicle_registration',
  addLpRegistration = 'lp_registration',
  share = 'share',
  congratulations = 'congratulations',
}
